/* iSpice "Build your spice box" - 2026-10-07
   The box: pick items (max = data-max), see which savings level you reach, then add everything to the
   normal cart. The discount itself is the store's automatic discount on the same collection, so the
   numbers here are an estimate of what the cart will show. One discount applies: the highest level.
   The box is remembered in this browser (localStorage) so a refresh does not empty it. */
(function () {
  'use strict';
  var KEY = 'isx_bundle_box_v1';

  function init(root) {
    var max = +root.getAttribute('data-max') || 12;
    var tiers = root.getAttribute('data-tiers').split(',').map(function (t) { var a = t.split(':'); return { qty: +a[0], pct: +a[1] }; });
    var moneyFmt = root.getAttribute('data-money') || '${{amount}}';
    var items = Array.prototype.slice.call(root.querySelectorAll('.isx-bd-item'));
    var byId = {};
    items.forEach(function (li) {
      byId[li.dataset.id] = { li: li, id: li.dataset.id, price: +li.dataset.price, name: li.dataset.name, img: li.dataset.img };
    });

    var box = [];   // list of variant ids, one per jar, in the order they were added
    try { box = (JSON.parse(localStorage.getItem(KEY) || '[]') || []).filter(function (id) { return byId[id]; }).slice(0, max); } catch (e) { box = []; }

    var portal = document.createElement('div'); portal.className = 'isx-bd isx-bd-portal';
    // the box and dock may live in the portal (phones), so every lookup checks both places
    function $(s) { return root.querySelector(s) || portal.querySelector(s); }
    function $$(s) { return Array.prototype.slice.call(root.querySelectorAll(s)).concat(Array.prototype.slice.call(portal.querySelectorAll(s))); }
    function money(cents) {
      var v = (Math.round(cents) / 100).toFixed(2);
      var withCommas = v.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return moneyFmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100)).replace(/\{\{\s*amount\s*\}\}/, withCommas).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v.replace('.', ',')).replace(/<[^>]+>/g, '');
    }
    function count(id) { return box.filter(function (x) { return x === id; }).length; }
    function level(n) { var lv = -1; tiers.forEach(function (t, i) { if (n >= t.qty) lv = i; }); return lv; }
    function save() { try { localStorage.setItem(KEY, JSON.stringify(box)); } catch (e) { /* private mode: the box simply is not remembered */ } }

    function render() {
      var n = box.length, lv = level(n);
      var sub = box.reduce(function (s, id) { return s + byId[id].price; }, 0);
      var pct = lv >= 0 ? tiers[lv].pct : 0;
      var off = Math.round(sub * pct / 100);

      // cards
      items.forEach(function (li) {
        var c = count(li.dataset.id);
        li.classList.toggle('is-in', c > 0);
        li.querySelector('[data-isx-bd-add]').hidden = c > 0;
        li.querySelector('[data-isx-bd-add]').disabled = n >= max;
        var step = li.querySelector('.isx-bd-step');
        step.hidden = c === 0;
        li.querySelector('[data-isx-bd-qty]').textContent = c;
        li.querySelector('[data-isx-bd-plus]').disabled = n >= max;
      });
      // slots
      var slots = $$('.isx-bd-slot');
      slots.forEach(function (s, i) {
        var id = box[i];
        var had = s.dataset.id;
        if (id === had) return;
        s.dataset.id = id || '';
        s.classList.toggle('is-full', !!id);
        s.innerHTML = id ? '<img src="' + byId[id].img + '" alt="">' + '<button type="button" data-isx-bd-out="' + i + '" aria-label="Remove ' + byId[id].name.replace(/"/g, '&quot;') + '">×</button>' : '';
      });
      // meter, levels, nudge
      $('[data-isx-bd-fill]').style.width = Math.min(100, n / max * 100) + '%';
      $$('[data-isx-bd-levels] li').forEach(function (li, i) { li.classList.toggle('is-on', i === lv); });
      $$('.isx-bd-mark').forEach(function (m) { m.classList.toggle('is-hit', n >= +m.getAttribute('data-n')); });
      var next = tiers.filter(function (t) { return n < t.qty; })[0];
      var nudge = n === 0 ? 'Your box is empty. Add any ' + tiers[0].qty + ' to start saving.'
        : next ? 'Add <b>' + (next.qty - n) + ' more</b> to save <b>' + next.pct + '%</b>' + (lv >= 0 ? ' (now ' + tiers[lv].pct + '%)' : '') + '.'
        : n >= max ? 'Your box is full: <b>' + tiers[lv].pct + '% off</b> unlocked.' : 'Top saving unlocked: <b>' + tiers[lv].pct + '% off</b>.';
      $('[data-isx-bd-nudge]').innerHTML = nudge;
      var hint = $('[data-isx-bd-hint]');
      if (hint) hint.innerHTML = n === 0 ? 'Add any ' + tiers[0].qty + ' to start saving.' : nudge;
      // numbers
      $$('[data-isx-bd-n]').forEach(function (e) { e.textContent = n; });
      $('[data-isx-bd-sub]').textContent = money(sub);
      $('[data-isx-bd-save]').textContent = off ? '−' + money(off) + ' (' + pct + '%)' : '—';
      $$('[data-isx-bd-total]').forEach(function (e) { e.textContent = money(sub - off); });
      var dt = $('[data-isx-bd-docktxt]');
      if (dt) dt.textContent = n === 0 ? 'Your gift box' : (lv >= 0 ? pct + '% off unlocked' : (tiers[0].qty - n) + ' more to save ' + tiers[0].pct + '%');
      var cartBtn = $('[data-isx-bd-cart]');
      cartBtn.disabled = n === 0;
      cartBtn.textContent = n === 0 ? 'Add box to cart' : 'Add ' + n + (n === 1 ? ' item' : ' items') + ' to cart';
      $('[data-isx-bd-clear]').hidden = n === 0;
      save();
    }

    function add(id, from) { if (box.length < max) { box.push(id); render(); fly(from, box.length - 1); } }

    // the jar photo flies from its card into its slot in the box (on phones, into the bottom bar)
    var still = matchMedia('(prefers-reduced-motion: reduce)').matches;
    function fly(li, slotIndex) {
      if (still || !li || !root.hasAttribute('data-fly')) return;
      var img = li.querySelector('.isx-bd-card__img img');
      var slot = $$('.isx-bd-slot')[slotIndex];
      if (!img || !slot) return;
      var boxEl = $('[data-isx-bd-box]'), dockBtn = $('[data-isx-bd-open]');
      var sheetClosed = matchMedia('(max-width: 900px)').matches && !boxEl.classList.contains('is-open');
      var target = sheetClosed ? dockBtn : slot;
      var a = img.getBoundingClientRect(), b = target.getBoundingClientRect();
      if (!a.width || !b.width || b.bottom < 0 || b.top > innerHeight) return;
      var ghost = img.cloneNode(); ghost.removeAttribute('srcset'); ghost.removeAttribute('sizes'); ghost.src = img.currentSrc || img.src;
      ghost.className = 'isx-bd-fly';
      ghost.style.cssText = 'left:' + a.left + 'px;top:' + a.top + 'px;width:' + a.width + 'px;height:' + a.height + 'px';
      document.body.appendChild(ghost);
      var size = sheetClosed ? 34 : b.width * .84;
      var dx = b.left + b.width / 2 - (a.left + a.width / 2), dy = b.top + b.height / 2 - (a.top + a.height / 2), s = size / a.width;
      var lift = Math.min(160, Math.abs(dx) * .35 + 60);   // a gentle arc: up first, then down into the box
      if (sheetClosed) slot.style.visibility = ''; else slot.style.visibility = 'hidden';
      var anim = ghost.animate([
        { transform: 'translate(0,0) scale(1) rotate(0deg)', opacity: 1 },
        { transform: 'translate(' + dx * .5 + 'px,' + (dy * .5 - lift) + 'px) scale(' + (1 + s) / 2 + ') rotate(-12deg)', opacity: 1, offset: .5 },
        { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(' + s + ') rotate(0deg)', opacity: 1 }
      ], { duration: 700, easing: 'cubic-bezier(.45,.05,.3,1)' });
      anim.onfinish = function () {
        ghost.remove(); slot.style.visibility = '';
        if (sheetClosed && dockBtn) { dockBtn.classList.remove('is-bump'); void dockBtn.offsetWidth; dockBtn.classList.add('is-bump'); }
      };
    }
    function remove(id) { var i = box.lastIndexOf(id); if (i > -1) { box.splice(i, 1); render(); } }

    function onClick(e) {
      var li = e.target.closest('.isx-bd-item');
      if (e.target.closest('[data-isx-bd-add], [data-isx-bd-plus]') && li) { add(li.dataset.id, li); return; }
      if (e.target.closest('[data-isx-bd-minus]') && li) { remove(li.dataset.id); return; }
      var out = e.target.closest('[data-isx-bd-out]');
      if (out) { box.splice(+out.getAttribute('data-isx-bd-out'), 1); render(); return; }
      if (e.target.closest('[data-isx-bd-clear]')) { box = []; render(); return; }
      if (e.target.closest('[data-isx-bd-open]')) { sheet(true); return; }
      if (e.target.closest('[data-isx-bd-close], [data-isx-bd-scrim]')) { sheet(false); return; }
      var chip = e.target.closest('.isx-bd-chip');
      if (chip) { filter.f = chip.dataset.f; applyFilter(); return; }
      if (e.target.closest('[data-isx-bd-reset]')) { filter.f = 'all'; filter.q = ''; $('[data-isx-bd-find]').value = ''; applyFilter(); }
    }
    root.addEventListener('click', onClick);
    portal.addEventListener('click', onClick);

    // filters
    var filter = { f: 'all', q: '' };
    function applyFilter() {
      var shown = 0, q = filter.q.toLowerCase();
      items.forEach(function (li) {
        var ok = true, f = filter.f;
        if (f.indexOf('type:') === 0) ok = li.dataset.type === f.slice(5);
        else if (f.indexOf('col:') === 0) ok = (' ' + li.dataset.colls + ' ').indexOf(' ' + f.slice(4) + ' ') > -1;
        if (ok && q) ok = (li.dataset.name + ' ' + li.dataset.size).toLowerCase().indexOf(q) > -1;
        li.hidden = !ok; if (ok) shown++;
      });
      $$('.isx-bd-chip').forEach(function (c) { var on = c.dataset.f === filter.f; c.classList.toggle('is-on', on); c.setAttribute('aria-selected', String(on)); });
      $('[data-isx-bd-empty]').hidden = shown > 0;
    }
    var find = $('[data-isx-bd-find]');
    if (find) find.addEventListener('input', function () { filter.q = find.value.trim(); applyFilter(); });

    // phones: the box opens as a bottom sheet; move it and the dock to <body> so no theme wrapper
    // with a transform can trap the fixed position
    var boxEl = $('[data-isx-bd-box]'), scrim = $('[data-isx-bd-scrim]'), dock = $('[data-isx-bd-dock]');
    var mq = matchMedia('(max-width: 900px)');
    var home = boxEl.parentNode;
    function place() {
      if (mq.matches && boxEl.parentNode !== portal) { portal.appendChild(scrim); portal.appendChild(boxEl); portal.appendChild(dock); document.body.appendChild(portal); }
      else if (!mq.matches && boxEl.parentNode === portal) { home.appendChild(boxEl); root.appendChild(dock); root.appendChild(scrim); sheet(false); }
    }
    function sheet(open) {
      boxEl.classList.toggle('is-open', !!open);
      scrim.hidden = !open;
      document.documentElement.style.overflow = open ? 'hidden' : '';
    }
    place();
    if (mq.addEventListener) mq.addEventListener('change', place);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') sheet(false); });

    // add the whole box to the cart
    $('[data-isx-bd-cart]').addEventListener('click', function () {
      var btn = this; if (!box.length) return;
      var q = {}; box.forEach(function (id) { q[id] = (q[id] || 0) + 1; });
      var lines = Object.keys(q).map(function (id) { return { id: +id, quantity: q[id], properties: { _bundle: 'iSpice gift box' } }; });
      btn.disabled = true; btn.textContent = 'Adding your box…';
      fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: lines }) })
        .then(function (r) { if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || ('add ' + r.status)); }); return r.json(); })
        .then(function () {
          return fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ attributes: { 'Gift box': 'Yes (' + box.length + ' items)' } }) }).catch(function (e) { console.warn('ispice-bundle attributes', e); });
        })
        .then(function () { box = []; save(); location.href = '/cart'; })
        .catch(function (err) {
          console.warn('ispice-bundle add to cart', err);
          btn.disabled = false; btn.textContent = 'Try again';
          $('[data-isx-bd-nudge]').textContent = 'Could not add the box: ' + err.message;
        });
    });

    applyFilter();
    render();
    root.classList.add('is-ready');
  }

  function start() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-isx-bd]'), function (root) {
      if (root.dataset.isxDone) return;
      root.dataset.isxDone = '1';
      try { init(root); } catch (e) { console.warn('ispice-bundle', e); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
